import { useCallback } from 'react';
import XLSX from 'xlsx';

export type ExcelExportRow = { [x: string]: string | number };

export default function useExcelExport() {
  return useCallback(
    (
      dataToExport: ExcelExportRow[],
      excelFileName: string,
      excelFileTabName?: string
    ) => {
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(dataToExport);
      XLSX.utils.book_append_sheet(wb, ws, excelFileTabName ?? excelFileName);
      XLSX.writeFile(wb, `${excelFileName}.xlsx`);
    },
    []
  );
}
